import { api } from '@/api'
import { Period } from '@/ui-kit'
import { UseQueryResult, useQuery } from '@tanstack/react-query'

export function useFetchWorkerJobs(
  workerId: string | undefined,
  period: Period
): UseQueryResult<Record<Period, Record<string, string>>> {
  return useQuery({
    enabled: !!workerId,
    queryKey: ['useFetchWorkerJobs', workerId, period],
    queryFn: () => api.get(`/worker/stats/jobs?id=${workerId}&period=${period}`),
    staleTime: 0,
    retry: 0
  })
}
